/**
 * ## Reservation Controller
 *
 * @module src/controllers/reservation
 */

"use strict";

const component = require("../../components/component");
const notification = require("../../components/notification");
const block = require("../../components/block");
const modal = require("../../components/modal");
const print = require("../../components/print");
const location = require("../../controllers/location");
const conf = require("../../config");
const chart = require("../../controllers/chart");
const moment = require("moment-timezone");
const tabs = require("../../controllers/tabs");
const l = require("../../common").localization;

/** Init
 */
const init = (kd) => {
  // today

  const opt = {
    kd,
    targetDiv: "content_standard_resnoshows",
    date: parseInt(moment().startOf("day").format("X"), 10),
    confirmation: true,
    filter: {
      name: true,
      time: false,
      note: false,
      preference: false,
    },
  };

  const data = {
    type: "resnoshows",
    domain: "reservation",
    h1: l.translate("Reservation No Shows"),
    h2: l.translate("..."),
    expand: true,
    single: true,
    group: "all",
    refresh: 30,
    height: {
      min: 69 * 2,
    },
    status: {
      min: 6,
      max: 6,
    },
    size: {
      min: 1,
      max: 8,
    },
    waited: {
      min: 0,
      max: 2000,
    },
  };

  block.create(opt, data, (err, target_id, activity_id) => {
    flyoutWaitlist(kd, target_id, activity_id);
  });

  // wide res no shows

  if (conf.vars.ui === "reservation") {
    const opt = {
      kd,
      targetDiv: "content_wide_resnoshows",
      date: parseInt(moment().startOf("day").format("X"), 10),
      confirmation: true,
      filter: {
        name: true,
        time: false,
        note: false,
        preference: false,
      },
    };

    const data = {
      type: "resnoshows",
      domain: "reservation",
      h1: l.translate("Reservation No Shows"),
      h2: l.translate("..."),
      expand: true,
      single: true,
      group: "all",
      refresh: 30,
      height: {
        min: 69 * 2,
      },
      status: {
        min: 6,
        max: 6,
      },
      size: {
        min: 1,
        max: 8,
      },
      waited: {
        min: 0,
        max: 2000,
      },
    };

    block.create(opt, data, (err, target_id, activity_id) => {
      flyoutWaitlist(kd, target_id, activity_id);
    });
  }
};

const flyoutWaitlist = (kd, target_id, reservation_id) => {
  const options = {
    target_id,
    type: "accordion",
    mode: "context_resnoshows",
    position: "left",
    adjust: {
      x: -5,
      y: 35,
    },
  };
  const data = {
    kd,
    activity: kd.doc("reservation", reservation_id)[0],
  };

  component.create(options, data, (err, data2) => {
    const rightNow = Math.floor(Date.now() / 1000);
    switch (data2.value) {
      case "seatparty": {
        const resdata = Object.assign({}, data2.activity);
        resdata.res_id = resdata._id;
        resdata.statusTimes = {
          added: rightNow,
          seated: rightNow,
        };
        delete resdata._id;
        chart.setSeatParty(resdata, "reservations");
        if (
          resdata.hasOwnProperty("preSelect") &&
          resdata.preSelect.length > 0
        ) {
          chart.chart.setHighlight(resdata.preSelect);
          kd.emit("chart.update", {});
        } else {
          kd.emit("directseat", { preference: data.activity.preference });
          tabs.tab(kd, "direct", {
            minimal: true,
            size: resdata.size,
          });
        }
        const opt = {
          position: "top",
          block: "header",
          width: "90%",
          seconds: 0,
          color: "#09e202",
          h1: l.translate("Please select a table to seat this reservation."),
          body: "",
          buttons: [
            {
              description: l.translate("Cancel"),
              value: "close",
            },
          ],
        };
        notification.create(opt, {}, (err2, value) => {
          kd.emit("directseat", { preference: null });
          notification.destroy();
          chart.clearSeatParty();
          chart.chart.clearHighlight();
          kd.emit("chart.update", {});
          tabs.tab(kd, "reservations");
        });
        break;
      }
      case "rescancel": {
        const proposed = {
          domain: "reservation",
          _id: data2.activity._id,
          status: 4,
        };
        const opt = {
          position: "top",
          width: "90%",
          seconds: 0,
          h1: l.translate("Are you sure you want to cancel this reservation?"),
          body: "",
          buttons: [
            {
              description: l.translate("Yes, cancel it."),
              value: "cancelres",
            },
            {
              description: l.translate("No, leave it."),
              value: "close",
            },
          ],
        };
        notification.create(opt, {}, (err3, value) => {
          notification.destroy();
          if (value === "cancelres") {
            kd.update(proposed)
              .then((result) => {
                const opt2 = {
                  position: "top",
                  width: "90%",
                  seconds: 2,
                  color: "#09e202",
                  h1: l.translate("Reservation has been cancelled."),
                  body: "",
                  buttons: [
                    {
                      description: l.translate("Close"),
                      value: "close",
                    },
                  ],
                };
                notification.create(opt2, {}, (err6, value2) => {
                  notification.destroy();
                });
              })
              .catch((err7) => {
                console.log("err7", err7);
              });
          }
        });
        break;
      }
      case "movetores": {
        const proposed = {
          domain: "reservation",
          _id: data2.activity._id,
          status: 1,
        };
        kd.update(proposed)
          .then((result) => {
            const opt2 = {
              position: "top",
              width: "90%",
              seconds: 2,
              color: "#09e202",
              h1: l.translate(
                "No show reservation has been moved back to the " +
                  "reservations list."
              ),
              body: "",
              buttons: [
                {
                  description: l.translate("Close"),
                  value: "close",
                },
              ],
            };
            notification.create(opt2, {}, (err6, value2) => {
              notification.destroy();
            });
          })
          .catch((err7) => {
            console.log("err7", err7);
          });
        break;
      }
      case "details": {
        const opt6 = {
          width: "90%",
          type: "addparty",
          subtype: "waitlist",
          mode: "reservations",
          h1: "Dialog Header",
          body: "This is the body text inside the dialog box",
          buttons: [
            {
              description: "cancel",
              value: "cancel...",
            },
            {
              description: "close",
              value: "close",
            },
            {
              description: "third",
              value: "close",
            },
          ],
        };

        const data6 = {
          kd,
          location: location.location,
          activity: data2.activity,
        };
        modal.create(opt6, data6, (err6, value) => {
          modal.destroy();
        });
        break;
      }
      case "printchit": {
        modal.destroy();
        setTimeout(() => {
          const opt = {
            type: "reservation",
            location: location.location,
          };
          print.create(opt, data2.activity);
        }, 10);
        break;
      }
      default:
        break;
    }
  });
};

module.exports = {
  init,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/resnoshows/index.js
 **/